const MixedAdultTooth = [3, 7, 8, 9, 10, 14, 30, 26, 25, 24, 23, 19];

export default MixedAdultTooth;
